import { useState } from 'react';
import Button from '../../../components/form-control/Button';
import Input from '../../../components/form-control/Input';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { addVehicle } from '../../../api/requests';
import SelectMenu from '../../../components/form-control/SelectMenu';
import { IAddSupportedVehicle, IEnum } from '../../../resources/interfaces';
import { capitalizeSentence, getSelectableManufacturingYears, showToast } from '../../../utils/miscFunctions';
import SelectDropdown, { ISelectDropdownItem } from '../../../components/form-control/SelectDropdown';
import { useSelector } from 'react-redux';
import { getEnumsFromState } from '../../../states/slices/resourceSlice';

const MANUFACTURED_YEARS_LIST = getSelectableManufacturingYears();

const AddVehicle = ({ onProceed, onClose }: { onProceed: () => void; onClose: () => void }) => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const enums = useSelector(getEnumsFromState);

  const submitHandler = (values: any) => {
    setSubmitting(true);
    const payload: IAddSupportedVehicle = {
      maker: values.maker,
      model: values.model,
      vehicleTypeName: values.type,
      yearIssued: values.yearIssued,
      maxSeat: values.maxSeat,
      miniSeat: values.miniSeat,
      cc: values.cc
    };

    addVehicle(payload)
      .then((response: any) => {
        showToast.success(response?.message || 'Vehicle added successfully',);
        onProceed();
      })
      .catch((error: any) => {
        showToast.error(error?.description);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Formik
      initialValues={{
        maker: '',
        model: '',
        type: '',
        yearIssued: '',
        maxSeat: '',
        miniSeat: '',
        cc: ''
      }}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={Yup.object().shape({})}
      onSubmit={(values) => {
        submitHandler(values);
      }}>
      {({
        values,
        errors,
        isSubmitting,
        handleSubmit,
        handleChange,
        setFieldValue,
        handleBlur,
        touched
      }) => (
        <form className="rounded-xl bg-white" onSubmit={handleSubmit}>

          <div className="px-10 py-[47px]">
            <div className="mb-8">
              <Input
                type={'text'}
                name="maker"
                placeholder="Vehicle"
                value={values.maker}
                onChange={handleChange}
                onBlur={handleChange}
                label="Vehicle Make"
              />
            </div>
            <div className=" grid grid-cols-1 md:gap-8 items-center   md:grid-cols-2 ">
              <div className="">
                <SelectDropdown
                  label="Vehicle Type"
                  name="type"
                  listSelectedValue={values.type}
                  onChange={(val: ISelectDropdownItem | null) => {
                    setFieldValue('type', val);
                  }}
                  onBlur={handleBlur}
                  search
                  searchPlaceHolder="Search by vehicle type ..."
                  list={enums?.vehicleBodyTypes?.map((type: IEnum) => ({
                    name: capitalizeSentence(type.title),
                    value: type.key
                  }))}
                  placeholder="Select vehicle type"
                  error={touched.type ? errors.type : undefined}
                  helperText={touched?.type ? errors.type : undefined}
                  required
                />
              </div>
              <div className="">
                <Input
                  type={'text'}
                  name="model"
                  value={values.model}
                  onChange={handleChange}
                  onBlur={handleChange}
                  label="Model"
                  placeholder=""
                />
              </div>
              <div className="">
                <Input
                  type={'number'}
                  name="cc"
                  // error={errors.email}
                  // helperText={errors.email}
                  min={50}
                  value={values.cc}
                  onChange={handleChange}
                  onBlur={handleChange}
                  label="Cubic Capacity"
                  placeholder=""
                />
              </div>

              <div className="">
                <Input
                  type="number"
                  name="miniSeat"
                  min={2}
                  value={values.miniSeat}
                  onChange={handleChange}
                  onBlur={handleChange}
                  label="Min. no of seats"
                  placeholder=""
                />
              </div>
              <div className="">
                <Input
                  type="number"
                  name="maxSeat"
                  onChange={handleChange}
                  value={values.maxSeat}
                  min={2}
                  onBlur={handleChange}
                  label="Max. no of seats"
                  placeholder=""
                />
              </div>
              <SelectMenu
                label="Latest model year"
                name="yearIssued"
                listSelectedValue={values.yearIssued}
                onChange={(val: string | null) => {
                  setFieldValue('yearIssued', val);
                }}
                onBlur={handleBlur}
                list={MANUFACTURED_YEARS_LIST}
                placeholder="Select Latest model year"
                // error={touched.manufacturedYear ? errors.manufacturedYear : undefined}
                required
                sort
                emptyListMessage="Select Latest model year to proceed"
              />
            </div>

            <div className="w-full flex gap-4 mt-5">
              <Button
                label="Cancel"
                bgColor='secondary'
                fullWidth
                onClick={onClose}
              />
              <Button
                label="Save"
                type="submit"
                bgColor='primary'
                fullWidth
              // loading={submitting}
              // disabled={submitting}
              />
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default AddVehicle;
